import * as React from 'react';
import { observer } from 'mobx-react';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { IButtonProps, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import strings from 'owa-strings/owa-options-strings';

export interface AddStorageAccountCalloutProps extends LightningProps {
    target: () => HTMLElement;
}

@observer
@lightable
export class AddStorageAccountCallout extends React.Component<AddStorageAccountCalloutProps, {}> {
    render() {
        const gotItButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: strings.options_callout_addStorageAccount_button,
            onClick: this.onClose,
        };

        return (
            <TeachingBubble
                calloutProps={{
                    beakWidth: 15,
                    directionalHint: DirectionalHint.rightCenter,
                    minPagePadding: 50,
                    gapSpace: 20,
                }}
                targetElement={this.props.target()}
                hasCloseIcon={true}
                onDismiss={this.onClose}
                hasSmallHeadline={true}
                headline={strings.options_callout_addStorageAccount_title}
                primaryButtonProps={gotItButtonProps}>
                {strings.options_callout_addStorageAccount_body}
            </TeachingBubble>
        );
    }

    private onClose = () => {
        lighted(this.props.lid);
    };
}
